var _defs, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAbsences(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122.72 122.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#11ccea;}.cls-2{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 61.36,
    cy: 61.36,
    r: 61.36
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M290,218.47H285.5v-8.88H236.32v3.8q0,13.25,0,26.5c0,.81.12.93.93.93,8.31,0,16.61,0,24.92,0h.93v4.6h-.62q-13.13,0-26.27,0c-1.67,0-4-1.86-4.23-3.4a24.1,24.1,0,0,1-.23-3.06q0-16.16,0-32.32c0-2,0-4,0-6a4.88,4.88,0,0,1,4.64-4.61c.71,0,1.41,0,2.19,0,0,.76,0,1.48,0,2.2a4.37,4.37,0,0,0,3.84,4.4,4.21,4.21,0,0,0,3.75-1.34,4.58,4.58,0,0,0,1.22-3.16c0-.68,0-1.36,0-2.07h27.05c0,.71,0,1.43,0,2.14a4.53,4.53,0,0,0,.83,2.66,4.37,4.37,0,0,0,3,1.76,4.31,4.31,0,0,0,4.79-3.15,6.28,6.28,0,0,0,.19-1.37c0-.66,0-1.32,0-2,3.17-.47,5.52.33,6.62,3.43A4.2,4.2,0,0,1,290,201c0,5.7,0,11.4,0,17.1C290.05,218.18,290,218.3,290,218.47Z",
    transform: "translate(-203.45 -160.29)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M285.51,258.8a17.89,17.89,0,0,1-17.91-16.41A18,18,0,0,1,287,222.94a18,18,0,0,1-1.52,35.86Zm0-4.59a13.34,13.34,0,1,0-13.32-13.81A13.33,13.33,0,0,0,285.51,254.21Z",
    transform: "translate(-203.45 -160.29)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M240.72,213.9h9v9h-9Z",
    transform: "translate(-203.45 -160.29)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M263.09,222.92h-9v-9h9Z",
    transform: "translate(-203.45 -160.29)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M240.71,227.43h9v9h-9Z",
    transform: "translate(-203.45 -160.29)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M263.1,227.45v9h-9v-9Z",
    transform: "translate(-203.45 -160.29)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.59,222.92h-9v-9c.14,0,.29,0,.44,0h8c.34,0,.61,0,.61.48,0,2.8,0,5.6,0,8.4C276.64,222.8,276.61,222.84,276.59,222.92Z",
    transform: "translate(-203.45 -160.29)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M240.66,193.78v-4.64a2.07,2.07,0,0,1,1.52-2,2.48,2.48,0,0,1,2.4.56,2.59,2.59,0,0,1,.69,1.89c0,2.9,0,5.79,0,8.69a2.31,2.31,0,0,1-1.43,2.12,2.24,2.24,0,0,1-2.45-.45,2.1,2.1,0,0,1-.72-1.75C240.68,196.75,240.66,195.26,240.66,193.78Z",
    transform: "translate(-203.45 -160.29)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M281.12,193.79v4.57a2.34,2.34,0,0,1-1.46,2.11,2.2,2.2,0,0,1-2.41-.48,2.13,2.13,0,0,1-.72-1.69c0-3,0-6.06,0-9.09a2.06,2.06,0,0,1,1.56-2.05,2.36,2.36,0,0,1,3,2.4c0,1.41,0,2.82,0,4.23Z",
    transform: "translate(-203.45 -160.29)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M285.59,240.81h6.69a2.29,2.29,0,0,1,2.1,1.39,2.44,2.44,0,0,1-.49,2.52,2.57,2.57,0,0,1-1.77.7c-3,0-5.95-.06-8.93,0a2.52,2.52,0,0,1-2.21-2.24c.06-3,0-6,0-9a2.3,2.3,0,0,1,4.6,0Z",
    transform: "translate(-203.45 -160.29)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbsences);
export default __webpack_public_path__ + "static/media/absences.4e4e24355d134d3a488f24d39e85d9e0.svg";
export { ForwardRef as ReactComponent };